import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  background: white;
  box-shadow: 0px 5px 10px rgba(0, 35, 75, 0.15);
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
`

export const ProfileImage = styled.img`
  width: 96px;
  min-height: 96px;
  align-self: stretch;
  object-fit: cover;
  @media(max-width: 768px) {
    width: 120px;
    height: 120px;
    min-height: 120px;
    flex-shrink: 0;
    align-self: auto;
  }
`

export const ContentWrapper = styled.div`
  flex: 1 1 0;
  padding: 16px 24px 16px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  @media(max-width: 768px) {
    padding-right: 16px;
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    min-height: 120px;
  }
`

export const LeftSection = styled.div`
  flex: 1 1 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
  @media(max-width: 768px) {
    align-self: stretch;
  }
`

export const ProfileInfo = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  @media(max-width: 768px) {
    width: 100%;
    height: 100%;
    gap: 16px;
  }
`

export const NameRow = styled.div`
  display: inline-flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  @media(max-width: 768px) {
    align-self: stretch;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 4px;
  }
`

export const Name = styled.div`
  color: #00234B;
  font-size: 22px;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: break-word;
  @media(max-width: 768px) {
    font-size: 18px;
    line-height: 20px;
  }
`

export const Badge = styled.div`
  padding: 5px 11px;
  background: #7F91A5;
  box-shadow: 0px 5px 10px rgba(127, 145, 165, 0.15);
  overflow: hidden;
  border-radius: 11px;
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  color: white;
  font-size: 10px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  white-space: nowrap;
  word-wrap: break-word;
  @media(max-width: 768px) {
    font-size: 8px;
  }
`

export const Details = styled.div`
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  @media(max-width: 768px) {
    align-self: stretch;
    flex-direction: column;
    gap: 0;
  }
`

export const DetailItem = styled.div`
  color: ${props => props.primary ? '#0082CE' : 'rgba(0, 35, 75, 0.50)'};
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  line-height: 22px;
  word-wrap: break-word;
`

export const SectionName = styled(DetailItem).attrs({ primary: true })``

export const FacilityName = styled(DetailItem)``

export const MemberId = styled(DetailItem)``

export const EditLink = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  @media(max-width: 768px) {
    gap: 4px;
  }
`

export const EditText = styled.div`
  color: #0082CE;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  line-height: 18px;
  word-wrap: break-word;
  @media(max-width: 768px) {
    display: none;
  }
`

export const ChevronIcon = styled.svg`
  width: 6px;
  height: 12px;
  fill: none;
  stroke: #0082CE;
  stroke-width: 1.5px;
  flex-shrink: 0;
  @media(max-width: 768px) {
    width: 9px;
    height: 12px;
  }
`
